export const compareAlphanumeric = (a, b) => {
  const numA = parseInt(a.match(/\d+/)[0]);
  const numB = parseInt(b.match(/\d+/)[0]);

  if (numA === numB) {
    return a.localeCompare(b);
  }

  return numA - numB;
};

export const truncateEmail = (email) => {
  if (email && email.length > 25) {
    return email.substring(0, 25) + "...";
  }
  return email;
};

export const truncateEmployeeName = (userName) => {
  if (userName && userName.length > 15) {
    return userName.substring(0, 15) + "...";
  }
  return userName;
};